import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import './Dashboard.css';

export default function Profile() {
  const [form, setForm] = useState({ bio: '', photo_url: '', profile_video_url: '', instagram_url: '', tiktok_url: '', spotify_url: '', contact_phone: '', contact_email: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadingVideo, setUploadingVideo] = useState(false);
  const [copied, setCopied] = useState(false);
  const [artistName, setArtistName] = useState('');
  const [artistSlug, setArtistSlug] = useState('');

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const res = await api.get('/artist-auth/me');
      setForm({
        bio: res.data.bio || '',
        photo_url: res.data.photo_url || '',
        profile_video_url: res.data.profile_video_url || '',
        instagram_url: res.data.instagram_url || '',
        tiktok_url: res.data.tiktok_url || '',
        spotify_url: res.data.spotify_url || '',
        contact_phone: res.data.contact_phone || '',
        contact_email: res.data.contact_email || '',
      });
      setArtistName(res.data.name);
      setArtistSlug(res.data.slug);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingVideo(true);
    try {
      const formData = new FormData();
      formData.append('video', file);
      const res = await api.post('/admin-upload/artist-self-video', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setForm((f) => ({ ...f, profile_video_url: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload video');
    } finally {
      setUploadingVideo(false);
      e.target.value = '';
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await api.post('/admin-upload/artist-self-photo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setForm({ ...form, photo_url: res.data.url });
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload foto');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/artist-auth/me', form);
      alert('Profil berhasil disimpan');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan profil');
    } finally {
      setSaving(false);
    }
  };

  const publicUrl = `https://saskararecord.com/artists/${artistSlug}`;

  const copyLink = () => {
    navigator.clipboard.writeText(publicUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('saskara_artist_token');
    localStorage.removeItem('saskara_artist_info');
    navigate('/login');
  };

  if (loading) return <p style={{ color: '#9A9AA2', padding: 24 }}>Memuat...</p>;

  return (
    <div className="artist-dashboard">
      <nav className="artist-nav">
        <span className="artist-nav__logo">SASKARA<span>RECORD</span></span>
        <div className="artist-nav__right">
          <a href="https://saskararecord.com" className="artist-nav__logout">Beranda</a>
          <Link to="/dashboard" className="artist-nav__logout" style={{ textDecoration: 'none' }}>Lagu Saya</Link>
          <span className="artist-nav__name">{artistName}</span>
          <button className="artist-nav__logout" onClick={handleLogout}>Logout</button>
        </div>
      </nav>

      <div className="artist-content">
      <p className="artist-greeting">Hai, {artistName} 👋</p>
      <h1 style={{ marginBottom: 8, marginTop: 4 }}>Profil Saya</h1>

      <div className="profile-share-box">
        <span className="profile-share-box__label">Halaman Publik Kamu</span>
        <div className="profile-share-box__row">
          <a href={publicUrl} target="_blank" rel="noreferrer" className="profile-share-box__link">
            {publicUrl}
          </a>
          <button type="button" className="profile-share-box__copy" onClick={copyLink}>
            {copied ? '✓ Tersalin' : 'Salin Link'}
          </button>
        </div>
        <p className="profile-share-box__hint">Bagikan link ini ke fans kamu di media sosial!</p>
      </div>

      <form onSubmit={handleSave} className="profile-form">
        <div className="profile-photo-row">
          <div className="profile-photo-box">
            {form.photo_url && <img src={form.photo_url} alt={artistName} />}
          </div>
          <label className="profile-upload-btn">
            {uploading ? 'Mengupload...' : '📁 Ganti Foto'}
            <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleFileUpload} disabled={uploading} style={{ display: 'none' }} />
          </label>
        </div>
        <label className="profile-label">Video Profil (opsional, maks 50MB, 1 video)</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <label className="profile-upload-btn">
            {uploadingVideo ? 'Mengupload...' : '📁 Upload Video'}
            <input type="file" accept="video/mp4,video/webm,video/quicktime" onChange={handleVideoUpload} disabled={uploadingVideo} style={{ display: 'none' }} />
          </label>
          {form.profile_video_url && (
            <video src={form.profile_video_url} muted style={{ width: 60, height: 60, borderRadius: 6, objectFit: 'cover', background: '#000' }} />
          )}
        </div>

        <label className="profile-label">Bio</label>
        <textarea rows={4} value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} />

        <label className="profile-label">Instagram URL</label>
        <input type="url" value={form.instagram_url} onChange={(e) => setForm({ ...form, instagram_url: e.target.value })} />

        <label className="profile-label">TikTok URL</label>
        <input type="url" value={form.tiktok_url} onChange={(e) => setForm({ ...form, tiktok_url: e.target.value })} />

        <label className="profile-label">Spotify URL</label>
        <input type="url" value={form.spotify_url} onChange={(e) => setForm({ ...form, spotify_url: e.target.value })} />

        <div className="profile-contact-section">
          <p className="profile-contact-title">🔒 Kontak Pribadi (tidak tampil di halaman publik)</p>
          <label className="profile-label">Nomor HP / WhatsApp</label>
          <input type="tel" value={form.contact_phone} onChange={(e) => setForm({ ...form, contact_phone: e.target.value })} placeholder="08xxxxxxxxxx" />

          <label className="profile-label">Email Kontak</label>
          <input type="email" value={form.contact_email} onChange={(e) => setForm({ ...form, contact_email: e.target.value })} placeholder="email@contoh.com" />
        </div>

        <button type="submit" className="btn-primary" disabled={saving} style={{ marginTop: 20, alignSelf: 'flex-start' }}>
          {saving ? 'Menyimpan...' : 'Simpan Profil'}
        </button>
      </form>
      </div>
    </div>
  );
}
